import React, { Component } from 'react';
import './App.scss';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Content from "./components/Content/Content";
import Home from "./components/Home/Home";
import PaymentResponse from "./components/PaymentResponse/PaymentResponse";
import Insurance from "./components/Insurance/Insurance";
import './assets/scss/core/_helpers.scss';

export default class App extends Component {
  render() {
    return (
      <Router>
        <div className="flex-container flex-dir-column fluid-y">
          <Header />

          <Content>

            <Switch>
              <Route path="/response/:lang?" component={PaymentResponse} />
              <Route path="/insurance/:lang?" component={Insurance} />
              {/*<Route path="/step1" render={ () => <PropertySearch /> } />*/}
              {/*<Route path="/step2" render={ () => <DataAddition /> } />*/}
              {/*<Route path="/step3" render={ () => <DataCheck /> } />*/}
              {/* <Route path="/step3" render={() => <Payment />} /> */}

              <Route path="/:lang?" component={Home} />
            </Switch>

          </Content>

          <Footer />
        </div>
      </Router>
    );
  }
}
